jQuery( document ).ready(function() {
  
  jQuery('#shopify-section-template--15537196368030__165033838369bf1d98 .featured-grid--subtitle').html('<a style="text-decoration:underline;" href="https://www.instagram.com/rozhair/">FOLLOW US</a>');
  jQuery('#shopify-section-template--15537196368030__165033838369bf1d98 .featured-grid--subtitle').css('font-style','normal');

  jQuery('<div class="press-quote"></div>').insertAfter(jQuery('#shopify-section-template--15537196368030__1649442500271a2fd8 .featured-grid--body'));

  jQuery('.product-page--block[data-block-type="collapsible-tab"] .collapsible-tab--content p:contains("#REVIEWS#")').replaceWith(jQuery('#shopify-product-reviews'));
          
  jQuery('#shopify-section-template--15537196368030__1649442500271a2fd8 .featured-grid--item--image').click(function() {
  	    var parent = jQuery(this).parent().parent().parent();
    	jQuery( parent ).each(function( index ) {
  			//jQuery(this).find('.featured-grid--item--text-container p').hide();
            jQuery(this).parent().find('.image--container img').css('filter','invert(0)');
		});
        //jQuery(this).parent().find('.featured-grid--item--text-container p').show();
        jQuery('.press-quote').text(jQuery(this).parent().find('.featured-grid--item--text-container p').text());
        jQuery(this).parent().find('.image--container img').css('filter','invert(100)');
  });
  
  jQuery('.page--landing-page-signup .custom-content--root .klaviyo-form-VSgETn').insertAfter('.featured-content--text');


  //jQuery('.page--foundation-shampoo .product-buy-buttons--cta-text').text("PREORDER");
  //jQuery('.page--foundation-conditioner .product-buy-buttons--cta-text').text("PREORDER");
  //jQuery('.page--the-foundation-duo .product-buy-buttons--cta-text').text("PREORDER");
  //jQuery('.page--willow-glen-treatment-oil .product-buy-buttons--cta-text').text("PREORDER");
  //jQuery('.page--repair-amp-style-kit .product-buy-buttons--cta-text').text("PREORDER");  
  //jQuery('.page--santa-lucia-styling-oil .product-buy-buttons--cta-text').text("PREORDER");
//  jQuery('.page--shop-roz-milk-hair-serum-with-hyaluronic-acid .product-buy-buttons--cta-text').text("COMING SOON");
  
});